"use client";

import React from "react";
import { useTranslation } from "next-i18next";

export default function Footer() {
  const { t } = useTranslation("footer");

  const handleSmoothScroll = (e, href) => {
    if (!href.startsWith("#")) return;

    e.preventDefault();

    const id = href.replace("#", "");
    const target = document.getElementById(id);
    if (target) {
      const y = target.getBoundingClientRect().top + window.pageYOffset - 64;
      window.history.pushState(null, "", href);
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const links = [
    { href: "#about", label: t("nav.about") },
    { href: "#service", label: t("nav.service") },
    { href: "#products", label: t("nav.products") },
    { href: "/request", label: t("nav.catalog") },
    { href: "#contact", label: t("nav.contact") },
  ];

  return (
    <footer className="footer border-t border-gray-300 md:border-t-0 md:pt-12 pb-0">
      <div className="w-full max-w-6xl mx-auto">
        <div className="bg-white rounded-none md:rounded-t-xl py-6 px-4 shadow-md text-center">
          <div className="font-extrabold font-montserrat text-lg mb-4 text-[#262104]">
            REEFLI
            <span className="align-super text-[0.65em] font-sans ml-0.5">
              ™
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-4 text-sm">
            {links.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                onClick={(e) => {
                  if (href.startsWith("#")) {
                    handleSmoothScroll(e, href);
                  }
                }}
                className="relative text-[#262104] cursor-pointer transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-[#262104] after:transition-all after:duration-300 hover:after:w-full"
              >
                {label}
              </a>
            ))}
          </div>

          <div className="text-xs text-gray-500 flex flex-wrap justify-center gap-6">
            <a
              href="/impressum"
              className="relative cursor-pointer transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[1.5px] after:bg-gray-400 after:transition-all after:duration-300 hover:after:w-full"
            >
              {t("legal.imprint")}
            </a>

            <a
              href="/datenschutz"
              className="relative cursor-pointer transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[1.5px] after:bg-gray-400 after:transition-all after:duration-300 hover:after:w-full"
            >
              {t("legal.privacy")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
